const formatAddress = ({
  street,
  postalCode,
  city,
}: {
  street?: string | null;
  postalCode?: string | number | null;
  city?: string | null;
}) => {
  const postalCodeAndCity = `${postalCode || ''} ${city || ''}`.trim();
  return [street, postalCodeAndCity].filter(Boolean).join(', ');
};

export default formatAddress;
